<template>
  <div class="">
    <v-view :tableData="tableData" :unstyled="false" :tableProps="tableProps" :modalProps="modalProps"
      :columns="columns" :routes="routes" :initialSort="initialSort" :buttonsVisibility="buttonsVisibility"
      :renderColumnValue="renderColumnValue" :rowButtonAction="rowButtonAction" :tooltipColumns="tooltipColumns"
      v-model:selectedRows="selectedRows">
      <template #crud="formProps">
        <UserForm :formProps="formProps"> </UserForm>
      </template>
      <template #search="searchProps">
        <UserSearch :searchProps="searchProps"> </UserSearch>
      </template>
    </v-view>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import UserForm from './UserForm.vue';
import UserSearch from './UserSearch.vue';
import { rowButtonAction } from '@pages/Helper/crud_utils.js';
import { __, screenMessage, getFromRoute } from '@pages/Helper/utils.js';

const props = defineProps({
  tableData: Object,
  tableProps: Object,
  modalProps: Object,
  columns: Object,
  routes: Object,
  tooltipColumns: Object,
  initialSort: Object,
  buttonsVisibility: Object,
});

const selectedRows = ref([]);

//------------------------------------------------------------------------------

const renderColumnValue = (field, value) => {
  switch (field) {
    case 'is_locked':
      return value == 1
        ? `<span class="inline-flex items-center gap-1 rounded-md bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700 inset-ring inset-ring-amber-600/20"><i class="fa-solid fa-lock text-xs"></i><span>${__('Locked')}</span></span>`
        : '';
    case 'is_active':
      return value == 1
        ? `<span class="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 inset-ring inset-ring-green-600/20">${__('Active')}</span>`
        : `<span class="inline-flex items-center rounded-md bg-red-50 px-2 py-1 text-xs font-medium text-red-700 inset-ring inset-ring-red-600/10">${__('Inactive')}</span>`;
    default:
      return value;
  }
};

//------------------------------------------------------------------------------
</script>

<style lang="scss" scoped></style>
